export var LINK_TYPE;
(function (LINK_TYPE) {
    LINK_TYPE[LINK_TYPE["H3"] = 0] = "H3";
    LINK_TYPE[LINK_TYPE["H4"] = 1] = "H4";
    LINK_TYPE[LINK_TYPE["H5"] = 2] = "H5";
    LINK_TYPE[LINK_TYPE["H6"] = 3] = "H6";
    LINK_TYPE[LINK_TYPE["BODY"] = 4] = "BODY";
    LINK_TYPE[LINK_TYPE["SMALL"] = 5] = "SMALL";
    LINK_TYPE[LINK_TYPE["EXTRA_SMALL"] = 6] = "EXTRA_SMALL";
    LINK_TYPE[LINK_TYPE["LARGE"] = 7] = "LARGE";
    LINK_TYPE[LINK_TYPE["EXTRA_LARGE"] = 8] = "EXTRA_LARGE";
})(LINK_TYPE || (LINK_TYPE = {}));
export var LINK_STYLE;
(function (LINK_STYLE) {
    LINK_STYLE[LINK_STYLE["BOLD"] = 0] = "BOLD";
    LINK_STYLE[LINK_STYLE["ITALIC"] = 1] = "ITALIC";
    LINK_STYLE[LINK_STYLE["LIGHT"] = 2] = "LIGHT";
    LINK_STYLE[LINK_STYLE["REGULAR"] = 3] = "REGULAR";
})(LINK_STYLE || (LINK_STYLE = {}));
